webpackJsonp([3],{

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _filter_links = _interopRequireDefault(__webpack_require__(169));

var _pagination = _interopRequireDefault(__webpack_require__(8));

var _cart = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const RIM_SEARCH */
var RIM_SEARCH = 'rims/search';
/**
 * @class RimsSearchHandler
 */

var RimsSearchHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function RimsSearchHandler() {
    _classCallCheck(this, RimsSearchHandler);

    this._listenLinkByFilters();

    new _pagination.default({
      url: 'rim/pagination',
      activeStatistic: true,
      additionalFilters: [{
        selector: '#frontoffice-filter-rims-search',
        event: 'keyup',
        key: 'search',
        default: null
      }, {
        selector: '#frontoffice-filter-rims-diameters',
        event: 'change',
        key: 'diameters',
        default: []
      }, {
        selector: '#frontoffice-filter-rims-widths',
        event: 'change',
        key: 'widths',
        default: []
      }, {
        selector: '#frontoffice-filter-rims-offset',
        event: 'change',
        key: 'offsets',
        default: []
      }, {
        selector: '#frontoffice-filter-rims-span',
        event: 'change',
        key: 'spans',
        default: []
      }, {
        selector: '#frontoffice-filter-rims-hub',
        event: 'change',
        key: 'hubs',
        default: []
      }, {
        selector: '#price-range-input-button',
        event: 'click',
        key: {
          from: 'priceLower',
          to: 'priceUpper',
          range: '#price-range-input'
        },
        default: null,
        type: 'range'
      }],
      responseCallbacks: [this._responseCallback]
    });
  }
  /**
   * @private
   */


  _createClass(RimsSearchHandler, [{
    key: "_listenLinkByFilters",
    value: function _listenLinkByFilters() {
      var that = this;
      $('#frontoffice-filter-rims-widths').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['širina'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-rims-diameters').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['prečnik'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-rims-offset').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['offset'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-rims-span').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['raspon'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-rims-hub').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['centralna_rupa'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
    }
    /**
     * @param response
     * @private
     */

  }, {
    key: "_responseCallback",
    value: function _responseCallback(response) {
      $('.add_to_cart').on('click', function (e) {
        e.preventDefault();

        _cart.default.addToCart($(e.target).data('cartitem'));
      });
    }
    /**
     * @param filtersArray
     * @private
     */

  }], [{
    key: "_generateLinkFromFilters",
    value: function _generateLinkFromFilters(filtersArray) {
      _filter_links.default.generateLinkFromFilters(filtersArray, RIM_SEARCH);
    }
  }]);

  return RimsSearchHandler;
}();
/** Start TiresSearchHandler */


$(document).ready(function () {
  new RimsSearchHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[272]);


// WEBPACK FOOTER //
// frontoffice_rims.js